module.exports = __webpack_public_path__ + "media/images/writer/monitor/pc-balloon@2x-8dab604b46a99a0cd7dfa384784587ca.png";